import { format, parseISO } from "date-fns";
import { pl } from "date-fns/locale";

export const formatDeliveryDate = (date: string): string => {
  const parsedDate = parseISO(date);
  return format(parsedDate, "EEEE, d.MM.yyyy", { locale: pl });
};
